import React from 'react';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import '../Footer/Footer.css';
import logo from '../Footer/logo2.png'; 
import { Link } from 'react-router-dom';
import { IoCall } from "react-icons/io5";

const Footer = () => {
  const callAdmin = () => {
    window.location.href = 'tel:02038852600';
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* First Column */}
        <div className="footer-col">
          <img src={logo} alt="Logo" className="footer-logo" />
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/flight">Flights</Link></li>
            <li><Link to="/holidays">Holidays</Link></li>
            <li><Link to="/aboutus">About Us</Link></li>
            <li><Link to="/contactus">Contact Us</Link></li>
            <div className="social-icons">
          <button className='button-11' onClick={callAdmin}><IoCall /> 02038852600</button>
          </div>
          </ul>
        </div>

        {/* Second Column */}
        <div className="footer-col">
          <h3>Popular Holidays</h3>
          <ul>
            <li><Link to="/holidays/turkey">Turkey</Link></li>
            <li><Link to="/holidays/morocco">Morocco</Link></li>
            <li><Link to="/holidays/dubai">Dubai </Link></li>
            <li><Link to="/holidays/maldives">Indian Ocean</Link></li>
            <li><Link to="/holidays/thailand">Thailand </Link></li>
            <li><Link to="/holidays/indonesia">Indonesia</Link></li>
            <li><Link to="/holidays/malaysia">Malaysia</Link></li>
          </ul>
        </div>

        {/* Third Column */}
        <div className="footer-col">
          <h3>Cheapest Flights</h3>
          <ul>
            <li><Link to="/flight/usa">Flights to USA</Link></li>
            <li><Link to="/flight/a&n">Flights to Australia & New Zealand</Link></li>
            <li><Link to="/flight/ca">Flights to Central America</Link></li>
            <li><Link to="/flight/fareast">Flights to Far East</Link></li>
            <li><Link to="/flight/india">Flights to India</Link></li>
            <li><Link to="/flight/middleeast">Flights to Middle East</Link></li>
            <li><Link to="/flight/caribbean">Flights to Caribbean</Link></li>
          </ul>
        </div>

        {/* Fourth Column */}
        <div className="footer-col">
          <h3>Travel Essentials</h3>
          <ul>
            <li><Link to="/privacyandpolicy">Privacy & Policy</Link></li>
            <li><Link to="/termsandconditions">Terms & Conditions</Link></li>
          </ul>

          {/* Social Connectivity */}
          <h3>Social Connectivity</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/people/Tripmart-Limited/61572941579629/#" target="_blank" rel="noopener noreferrer" className="social-icon"><FaFacebookF /></a>
            <a href="https://www.instagram.com/tripmart_limited/#" target="_blank" rel="noopener noreferrer" className="social-icon"><FaInstagram /></a>
            <a href="https://api.whatsapp.com/send?phone=442038852600&text=Hi%20Tripmart%2C%20I%E2%80%99d%20like%20to%20know%20more%20about%20your%20travel%20packages.
" className="social-icon" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
          </div>
        
          <h3>Payment Methods</h3>
          <div className="payment-methods">
            <img src="/visa.png" alt="Visa" className="payment-img" />
            <img src="/mastercard.png" alt="MasterCard" className="payment-img" />
            <img src="/american.png" alt="American Express" className="payment-img" />
          </div>
        </div>

       {/* Fifth Column - New Column */}

      </div>
      <div className="footer-col">
 
  <div className="partner-logos">
   <img src="/percent.png" alt="100%_financial_protection" className="partner-logo ta" />
    
    <img src="/badge.png" alt="pts" className="partner-logo" />
    <Link to="https://travelaware.campaign.gov.uk/">
      <img src="/travelaware.jpg" alt="travelaware" className="partner-logo" />
       </Link>
  
      
       <img src="/iata.png" alt="itatids" className="partner-logo ta" />
      {/*-
      <img src="/iatatids.png" alt="itatids" className="partner-logo" />
       <img src="/pts.png" alt="itatids" className="partner-logo" />
   
    -*/}
   
     
   
   
  </div>
</div>
      <div className="footer-bottom">
        <p>
          For the latest travel advice from the Foreign & Commonwealth Office including security and local laws, plus passport and visa information,  
          <a href='http://www.gov.uk/foreign-travel-advice' target='_blank'>click here</a>.
        </p>
        <p>Copyright &copy; {new Date().getFullYear()} - Trip Mart. All rights reserved. Company Registration Number: 16163446.</p>
        <p>
          Designed by{" "}
          <a href="https://infogainsoft.com" target="_blank" rel="noopener noreferrer">
            Infogainsoft
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;